module.exports = __webpack_public_path__ + "assets/img/002 (1).bd1e9275.jpg";